module.exports = __webpack_public_path__ + "img/1920_footer_icon1.42d300fc.svg";